import axiosInstance from "../../utils/axios";

const BASE_URL = "/departments";

const departmentService = {
  async getAll(params = {}) {
    const response = await axiosInstance.get(BASE_URL, { params });
    return response.data;
  },

  async getStatistics() {
    const response = await axiosInstance.get(`${BASE_URL}/statistics`);
    return response.data;
  },

  async getById(id) {
    const response = await axiosInstance.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  async create(payload) {
    const response = await axiosInstance.post(BASE_URL, payload);
    return response.data;
  },

  async update(id, payload) {
    const response = await axiosInstance.put(`${BASE_URL}/${id}`, payload);
    return response.data;
  },

  async delete(id) {
    const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return response.data;
  },
};

export default departmentService;